<template>
  <div v-loading="loading" style="min-height: 100px">
    <rj-timeline class="Processing">
      <rj-timeline-item v-for="(flow,index) in tableData" :key="index" :color="index!=0?'#909399':''">
        <p>{{ flow.content }}</p>
        <p>{{ flow.createTime }}</p>
      </rj-timeline-item>
    </rj-timeline>
    <no-data v-if="!tableData.length" />
  </div>
</template>
<script type="es6">
import timeLine from 'rjelement-components/packages/components/timeLine';
import timeLineItem from 'rjelement-components/packages/components/timeLineItem';
import noData from '@/components/noData';
import { getContractTrackingList } from '@/API';
export default {
  data () {
    return {
      loading: false,
      tableData: []
    };
  },
  components: {
    'rj-timeline': timeLine,
    'rj-timeline-item': timeLineItem,
    noData
  },
  props: {
    contractId: {
      type: [String, Number],
      required: true
    }
  },
  computed: {},
  methods: {
    initData () {
      this.loading = true;
      getContractTrackingList(this.contractId).then((res) => {
        let json = res.data;
        this.loading = false;
        if (json.status === '200') {
          this.tableData = json.data;
        }
      }).catch(() => {
        this.loading = false;
      });
    }
  },
  mounted () {
  // this.initData();
  }
};
</script>
<style lang="scss">
  @import "../../../../style/var";
  .Processing{
    p{
      margin-bottom: 6px;
    }
    .rj-timeline-item__tail{
      top: 6px;
    }
    .rj-timeline-item{
      padding: 0 0 5px;
      .rj-timeline-item__content{
        color: $--color-text-secondary;
      }
      &:first-child{
        .rj-timeline-item__content{
          color: $--color-primary;
        }
      }
    }
  }
</style>
